import React from "react";
import UserLink from "../components/UserLink";

/**
 * parseCaption — turn a raw caption string into React nodes where every
 * @username token is a tappable UserLink.
 *
 *   parseCaption("shoutout @glowbug for the trade!", friends)
 *
 * `friends` is optional; when provided it's used to attach the matching
 * userId to each UserLink (usernames still link without it — the /user/:username
 * route resolves by name).
 *
 * Used anywhere captions are displayed: PhotoViewerModal, feed cards, and
 * gallery thumbnail previews.
 */

// Same charset the MentionInput dropdown inserts: letters, digits, _ . -
const MENTION_RE = /@([A-Za-z0-9_.-]+)/g;

export function parseCaption(captionString, friends = []) {
  if (!captionString) return null;

  const byName = new Map(
    (friends || [])
      .filter((f) => f?.username)
      .map((f) => [f.username.toLowerCase(), f])
  );

  const nodes = [];
  let lastIndex = 0;
  let match;
  MENTION_RE.lastIndex = 0;

  while ((match = MENTION_RE.exec(captionString)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(
        <span key={`t${lastIndex}`}>{captionString.slice(lastIndex, match.index)}</span>
      );
    }
    const username = match[1];
    const friend = byName.get(username.toLowerCase());
    nodes.push(
      <UserLink
        key={`m${match.index}`}
        username={friend?.username || username}
        userId={friend?.id}
      />
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < captionString.length) {
    nodes.push(<span key={`t${lastIndex}`}>{captionString.slice(lastIndex)}</span>);
  }

  return nodes;
}

export default parseCaption;
